<div class="table-responsive">
  <table class="table table-borderless table-striped table-hover">
    <thead>
      <tr>
        <th scope="col" translate>POD_NAME</th>
        <th scope="col" translate>POD_ADDRESS</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let deliveryLocation of data">
        <td>
          {{ deliveryLocation?.extra?.companyName || deliveryLocation.name }}
        </td>
        <td>
          {{ deliveryLocation?.extra?.address || deliveryLocation.extra.fr.ftgpostadr2 }}, {{ deliveryLocation?.extra?.postalCode || deliveryLocation.extra.fr.ftgpostnr }} ({{ deliveryLocation?.extra?.city || deliveryLocation.extra.fr.ftgpostadr3 }})
        </td>
        <td>
          <div class="d-flex flew-row justify-content-end">
            <button class="btn btn-outline-primary create-pod-button" (click)="openEditPOD(deliveryLocation)">
              <i class="fa fa-lg fa-pen-to-square"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
